module.exports = __webpack_public_path__ + "img/13.45baa1c4.jpg";